"use strict";
import { addEvent } from "../addEvent/addEvent";

export const mobileMenu = class {
  bodyClassName = "mobile-menu";
  bodyMobileMenuShowClassName = "mobile-menu-show";
  mobileMenuButtonClassName = "menu-button";
  mobileMenuContainerClassName = "full-site-menu-container";
  mobileMenuScrollContainerClassName = "full-site-menu";

  nav = false;
  navOffer = false;
  body = false;
  menuList = false;
  mobileMenuContainer = false;
  mobileMenuButton = false;
  mobileMenuButtonContainer = false;
  mobileShow = false;

  constructor() {
    let nav = document.getElementsByClassName("header__top-nav")[0];
    let navOffer = document.getElementsByClassName("header__main-nav")[0];
    this.nav = nav;
    this.navOffer = navOffer;
    this.menuList = nav.querySelector("ul").cloneNode(true);
    this.menuOfferList = navOffer.querySelector("ul").cloneNode(true);
    this.body = document.getElementsByTagName("body")[0];
    this.mobileMenuButtonContainer = document.getElementsByClassName(
      "header__menu-container"
    )[0];
    this.test();
    addEvent(window, "resize", () => {
      this.test();
    });
    return this;
  }

  test = () => {
    const { enabled, disabled } = this;

    const breakPoint = 1175;
    const widthWin = $(window).width();

    if (breakPoint > widthWin) {
      enabled();
    } else {
      disabled();
    }
  };

  enabled = () => {
    const { body, bodyClassName, _createMenuButton, _cereateMenuContainer } =
      this;
    body.classList.add(bodyClassName);
    _createMenuButton();
    _cereateMenuContainer();
  };

  disabled = () => {
    const { body, bodyClassName, _removeMenuButton, _remveMenuContainer } =
      this;
    body.classList.remove(bodyClassName);
    _removeMenuButton();
    _remveMenuContainer();
  };

  _cereateMenuContainer = () => {
    const {
      nav,
      body,
      mobileMenuContainerClassName,
      mobileMenuButtonContainer,
      mobileMenuScrollContainerClassName,
      menuList,
      menuOfferList,
    } = this;

    if (this.mobileMenuContainer) return;

    let mobileMenuContainer = document.createElement("div");
    mobileMenuContainer.classList.add(mobileMenuContainerClassName);

    let mobileMenuScrollContainer = document.createElement("div");
    mobileMenuScrollContainer.classList.add(mobileMenuScrollContainerClassName);

    let mobileMenuListsContainer = document.createElement("div");

    mobileMenuListsContainer.appendChild(menuList);
    mobileMenuListsContainer.appendChild(menuOfferList);
    mobileMenuScrollContainer.appendChild(mobileMenuListsContainer);

    mobileMenuContainer.appendChild(mobileMenuScrollContainer);

    this.mobileMenuContainer =
      mobileMenuButtonContainer.appendChild(mobileMenuContainer);
  };

  _remveMenuContainer = () => {
    if (!this.mobileMenuContainer) return;

    this.mobileMenuContainer.remove();
    this.mobileMenuContainer = false;
  };

  _createMenuButton = () => {
    const {
      body,
      nav,
      mobileMenuButtonContainer,
      mobileMenuButtonClassName,
      bodyMobileMenuShowClassName,
    } = this;
    if (this.mobileMenuButton) return;

    let div = document.createElement("div");
    let span = document.createElement("span");
    let span2 = document.createElement("span");
    let span3 = document.createElement("span");
    div.appendChild(span);
    div.appendChild(span2);
    div.appendChild(span3);

    let mobileButton = document.createElement("div");
    mobileButton.classList.add(mobileMenuButtonClassName);

    mobileButton.appendChild(div);

    this.mobileMenuButton = mobileMenuButtonContainer.appendChild(mobileButton);

    addEvent(this.mobileMenuButton, "click", (e) => {
      e.preventDefault();
      if (this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
      } else {
        body.classList.add(bodyMobileMenuShowClassName);
        this.mobileShow = true;
      }
    });

    addEvent(document, "keyup", (e) => {
      if (e.keyCode == 27 && this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
      }
    });
  };

  _removeMenuButton = () => {
    if (!this.mobileMenuButton) return;

    this.mobileMenuButton.remove();
    this.mobileMenuButton = false;
  };
};
